/*
 * 単一選択画面用
 * 共通部品
 */
<template>
	<div>
		<!-- 検索欄 -->
		<components
			v-show="r_is_search"
			:is="r_select_component_name"
			ref="if_search"
			:r_messages="r_messages"
			:r_settings="r_settings"
	 		:r_default="search_default"
			:r_default_name="search_name_default"
			:r_machine_model_cl="r_machine_model_cl"
			:r_disp="r_disp"
			@event_search="onBtnSearch">
		</components>
		<!-- メッセージ -->
		<div class="clearfix" id="disp-err-msg">
			<c-msgdisp
				:r_messages="r_messages"
				:r_info_msg="info_msg"
				:r_err_msg="err_msg"
				:r_initial_msg="initial_msg">
			</c-msgdisp>
		</div>
		<div>
			<!-- ページネーション上 -->
			<c-pagination
				ref="v_paging"
				v-show="is_list_disp"
				:r_messages="r_messages"
				:r_current_page='m_nPageNo'
				:r_disp_item_count='m_nPageDispCnt'
				:r_all_item_count='m_nAllInfoCnt'
				:r_cnt_prefix="cnt_prefix"
				:r_is_copy_search='true'
				:r_is_show_results='false'
				:r_is_show_fromto='true'
				@event_change_page="onChangePage">
			</c-pagination>
			<!-- 一覧表示 -->
			<div class="table-frame">
				<div class="table-responsive">
					<table class="search-list table-line" v-show="check_is_list_disp">
						<!-- ヘッダー -->
						<c-listheaders
							:r_items="list_header"
							:r_nowsortid="sort_id"
							@event_sort="onBtnSort">
						</c-listheaders>
						<!-- 条件なし（指定なし） -->
						<tr class="tr-td-control" :class="class_not_select" v-if="r_is_no_select && this.m_nPageNo == 1" @click="onNoSelect">
							<td class="td-controltext td-copy-area" :colspan="this.list_header.length">
								{{r_messages.not_select}}
							</td>
						</tr>
						<!-- 指示なし -->
						<tr class="tr-td-control" :class="class_no_instruction" v-if="r_is_no_instruction && this.m_nPageNo == 1" @click="onNoInstruction">
							<td class="td-controltext td-copy-area" :colspan="this.list_header.length">
								{{r_messages.no_instruction}}
							</td>
						</tr>
						<!-- 配信期間なし -->
						<tr class="tr-td-control" :class="class_term_send_always" v-if="r_is_term_send_always && this.m_nPageNo == 1" @click="onTermSendAlways">
							<td class="td-controltext td-copy-area" :colspan="this.list_header.length">
								{{r_messages.term_send_always}}
							</td>
						</tr>
						<!-- はかり優先 -->
						<tr class="tr-td-control" :class="class_model_dependent" v-if="r_is_model_dependent && this.m_nPageNo == 1" @click="onModelDependent">
							<td class="td-controltext td-copy-area" :colspan="this.list_header.length">
								{{r_messages.model_dependent}}
							</td>
						</tr>
						<!-- 設定なし -->
						<tr class="tr-td-control" :class="class_no_setting" v-if="r_is_no_setting && this.m_nPageNo == 1" @click="onNoSetting">
							<td class="td-controltext td-copy-area" :colspan="this.list_header.length">
								{{settingDisableMessage}}
							</td>
						</tr>
						<!-- 検索データ -->
						<c-listitem
							v-for="(info, key) in m_arrDispInfo"
							v-show="is_list_disp"
							:key="'info' + key"
							:r_id="key"
							:r_info="getListItemInfo(info)"
							:r_items="list_items"
							:class="class_code_or_name_only(info)"
							@event_tr="onListClick(key)">
							<!-- コード表示の実装部 -->
							<div slot="text_code" class="text_code_area">
								{{ info.text_code }}
							</div>
							<!-- 名称表示の実装部 -->
							<span slot="disp_text">
								<!-- 複数行名称表示の実装部 -->
								<c-labellist v-if="info.line" class="label-list" v-model="info.line"></c-labellist>
								<!-- 一行系名称表示の実装部 -->
								<div v-else>
									<span v-html="getDispText(info.disp_text)"></span>
								</div>
							</span>
						</c-listitem>
					</table>
				</div>
			</div>
			<!-- ページネーション下 -->
			<c-pagination
				ref="v_paging"
				v-show="is_list_disp"
				:r_messages="r_messages"
				:r_current_page='m_nPageNo'
				:r_disp_item_count='m_nPageDispCnt'
				:r_all_item_count='m_nAllInfoCnt'
				:r_cnt_prefix="cnt_prefix"
				:r_is_copy_search='true'
				:r_is_show_results='false'
				:r_is_show_fromto='false'
				@event_change_page="onChangePage">
			</c-pagination>
		</div>
	</div>
</template>
<script>
	import {COMMON_CONSTANT} from 'js/const/constants';
	export default {
		mixins: [
			// リスト機能
			require('js/common/list/listBase.mixin.vue'),
			// TABインデックス制御
			require('js/common/tabIndex.mixin.vue')
		],
		props: {
			'r_settings': {
				type: Object,
				required: true
			},
			'r_param': {
				type: Object,
				default: function(){
					return {};
				}
			},
			'r_select_default': {
				type: Object,
				default: function(){
					return {};
				}
			},
			'r_code': {
				type: [Number, String],
				default: -999999
			},
			'r_code_name': {
				type: String,
				default: 'text_code'
			},
			'r_code2': {
				type: [Number, String],
				default: -999999
			},
			'r_is_check_code2': {
				type: Boolean,
				default: false
			},
			'r_info': {},
			'r_list_header': {
				type: Array,
				default: function(){
					return [];
				}
			},
			'r_list_items': {
				type: Array,
				default: function(){
					return [];
				}
			},
			'r_is_no_select': {
				type: Boolean,
				default: false
			},
			'r_is_no_instruction': {
				type: Boolean,
				default: false
			},
			'r_is_term_send_always': {
				type: Boolean,
				default: false
			},
			'r_is_no_setting': {
				type: Boolean,
				default: false
			},
			'r_no_setting_name': {
				type: String,
				default: ''
			},
			'r_is_model_dependent': {
				type: Boolean,
				default: false
			},
			'r_select_component_name': {
				type: String,
				default: 'c-selectionifsearch',
				validator: function(val){
					return val != '';
				}
			},
			'r_machine_model_cl': {
				type: [Number, String],
				default: null
			},
			'r_add_search_param': null,
			'r_disp': {},
			'r_is_search': {
				type: Boolean,
				default: true
			},
			'r_key_code': {
				type: String,
				default: 'text_code'
			}
		},
		mounted: function(){
			for(let key in this.r_param){
				this.setAddSearchParam(key, this.r_param[key])
			}
			this.addInitialMsg(this.r_messages.select_messages);
			// 初回検索を実行
			this.if_search.search();
		},
		computed: {
			//! コード表示判定
			is_disp_code: function(){
				if(this.r_disp && this.r_disp.is_disp_code != undefined){
					return this.r_disp.is_disp_code;
				}
				return true;
			},
			//! 名称表示判定
			is_disp_name: function(){
				if(this.r_disp && this.r_disp.is_disp_name != undefined){
					return this.r_disp.is_disp_name;
				}
				return true;
			},
			check_is_list_disp: function(){
				if(this.is_list_disp || this.cnt_prefix > 0){
					return true;
				}
				return false;
			},
			// リストヘッダー定義
			list_header: function(){
				let arr = [];
				if(this.r_list_header.length > 0){
					arr = this.r_list_header;
				}else{
					const mes = this.r_messages;
					// コード
					if (this.is_disp_code) {
						arr.push({
							id: 1,													// ソートID ※0:ソート無効
							name: mes.text_code,									// 表示名
							class: "th-controltext sort-header stable-text-cell"	// クラス名
						});
					}
					// 名称
					if (this.is_disp_name) {
						arr.push({
							id: 2,								// ソートID ※0:ソート無効
							name: mes.disp_text,				// 表示名
							class: "th-controltext sort-header"	// クラス名
						});
					}
				}
				return arr;
			},
			// リストアイテム定義
			list_items: function(){
				let arr = [];
				if(this.r_list_items.length > 0){
					arr = this.r_list_items;
				}else{
					// 呼び出しコード
					if (this.is_disp_code) {
						arr.push({
							type: "slot",							// タイプ指定
							class: "td-controltext td-copy-area",	// クラス名
							name: "text_code"						// スロット名
						});
					}
					// 名称
					if (this.is_disp_name) {
						arr.push({
							type: "slot",							// タイプ指定
							class: "td-controltext td-copy-area",	// クラス名
							name: "disp_text"						// スロット名
						});
					}
				}
				return arr;
			},
			/**
			 * 更新の確定確認メッセージ override
			 */
			msg_confirm_update: function(){
				return this.r_messages.confirm_update;
			},
			// 検索IF アクセス
			if_search: function(){
				return this.$refs.if_search;
			},
			cnt_prefix: function(){
				let offset = 0;
				offset += this.r_is_no_instruction ? 1 : 0;
				offset += this.r_is_no_select ? 1 : 0;
				offset += this.r_is_no_setting ? 1 : 0;
				offset += this.r_is_term_send_always ? 1 : 0;
				offset += this.r_is_model_dependent ? 1 : 0;
				return offset;
			},
			search_default: function(){
				return Object.assign({}, this.r_select_default, this.search_default_codes);
			},
			search_name_default: function(){
				return this.search_default_name_max;
			},
			// 「設定なし」のメッセージを変更する
			settingDisableMessage: function(){
				if(this.r_no_setting_name != ''){
					return this.r_no_setting_name;
				}
				return this.r_messages.setting_disable;
			},
			// 指定なしのクラス
			class_not_select: function(){
				let className = '';
				if(this.r_code == COMMON_CONSTANT.NO_SELECT){
					className = 'tr-select';
				}
				return className;
			},
			// 指示なしのクラス
			class_no_instruction: function(){
				let className = '';
				if(this.r_code == COMMON_CONSTANT.NO_INSTRUCTION){
					className = 'tr-select';
				}
				return className;
			},
			// 配信期間なしのクラス
			class_term_send_always: function(){
				let className = '';
				if(this.r_code == COMMON_CONSTANT.TERM_SEND_ALWAYS){
					className = 'tr-select';
				}
				return className;
			},
			// はかり優先のクラス
			class_model_dependent: function(){
				let className = '';
				if(this.r_code == COMMON_CONSTANT.MODEL_DEPENDENT){
					className = 'tr-select';
				}
				return className;
			},
			// 設定なしのクラス
			class_no_setting: function(){
				let className = '';
				if(this.r_code == COMMON_CONSTANT.NO_SETTING && (!this.r_is_check_code2 || this.r_code2 <= COMMON_CONSTANT.NO_SETTING)){
					className = 'tr-select';
				}
				return className;
			},
			// 第二主キーの取得
			select_code2: function(){
				let code2 = COMMON_CONSTANT.MODEL_DEPENDENT;
				// r_select_component_nameの値に応じて参照する値を変える
				switch(this.r_select_component_name){
					case 'c-ifsearchstore':
					case 'c-ifsearch-shp0':
						// 店名
						code2 = this.$refs.if_search.m_store.code;
						break;
					case 'c-ifsearchformat':
					case 'c-selectionifsearchformat':
					case 'c-ifcopysearch-fml6':
						code2 = this.$refs.if_search.m_nModelType;
						// ラベルフォーマット
						break;
				}
				return code2;
			}
		},
		methods: {
			// 外部からのリスト検索要求 for override
			requestSearch: function(){
				this.if_search.search();
			},
			/**
			 * 表示リスト更新処理
			 */
			onUpdateList: function(){
				// リスト表示用のデータを生成する
				this.m_arrDispInfo = {};
				if(this.manager.convertDispItem){
					for(let key in this.m_arrInfo){
						let item = this.m_arrInfo[key];
						// 表示のアイテムに変換する
						this.m_arrDispInfo[key] = this.manager.convertDispItem(item, this.m_type);
					}
				}

				this.m_bListChange = this.checkUpdate(null);
			},
			onListClick: function(key){
				this.$emit("event_change", this.m_arrInfo[key], this.r_info);
			},
			/*
			 * 条件なし（指定なし）
			 */
			onNoSelect: function(){
				this.$emit('event_change', {text_code: COMMON_CONSTANT.NO_SELECT, disp_text: ''} , this.r_info);
			},
			/*
			 * 指示なし
			 */
			onNoInstruction: function(){
				this.$emit('event_change', {text_code: COMMON_CONSTANT.NO_INSTRUCTION, disp_text: ''} , this.r_info);
			},
			/*
			 * 配信期間なし
			 */
			onTermSendAlways: function(){
				this.$emit('event_change', {text_code: COMMON_CONSTANT.TERM_SEND_ALWAYS, disp_text: ''} , this.r_info);
			},
			/*
			 * はかり優先
			 */
			onModelDependent: function(){
				this.$emit('event_change', {text_code: COMMON_CONSTANT.MODEL_DEPENDENT, disp_text: ''}, this.r_info);
			},
			/*
			 * 設定なし
			 */
			onNoSetting: function(){
				this.$emit('event_change', {text_code: COMMON_CONSTANT.NO_SETTING, disp_text: this.r_messages.setting_disable}, this.r_info);
			},
			/**
			 * 検索処理の実行
			 */
			onSearch: function(param, isSearchBtn){
				// ページは1に変更
				this.m_nPageNo = 1;
				// r_is_copy_searchを引数として受け取っていることを前提としている。
				if(!this.r_is_copy_search && this.if_accordion && isSearchBtn){
					this.if_accordion.closeList();
				}

				if(this.r_add_search_param){
					const paramTmp = this.addSearchParam(this.r_add_search_param);
					param = $.extend(true, param, paramTmp);
				}

				// 検索パラメータの追加処理
				param = this.addSearchParam(param);
				this.doSearch(param);
			},
			// コードor名称のみのクラス
			class_code_or_name_only: function(info) {
				let className = '';
				switch (this.r_code) {
					case COMMON_CONSTANT.NO_SELECT:
					case COMMON_CONSTANT.NO_INSTRUCTION:
					case COMMON_CONSTANT.TERM_SEND_ALWAYS:
					case COMMON_CONSTANT.MODEL_DEPENDENT:
					case COMMON_CONSTANT.NO_SETTING:
						className = '';
						break;
					default:
						// コードのみ表示
						if (this.is_disp_code && !this.is_disp_name) {
							if(this.r_code == info.text_code) {
								className = 'tr-select';
							}
						// 名称のみ表示
						} else if (!this.is_disp_code && this.is_disp_name) {
							if(this.r_code == info.disp_text) {
								className = 'tr-select';
							}
						}
						break;
				}
				return className;
			},
			getDispText: function(text){
				if(text != undefined && text.indexOf("\n") >= 0){
					let idx = text.indexOf("\n");
					let temp = text.slice(0, idx) + "<br><span class='line-2'>" + text.slice(idx+1) + "</span>";

					idx = temp.indexOf("\n");
					if(idx > 0){
						temp = temp.slice(0, idx);
					}
					text = temp;
				}
				return text;
			},
			/**
			 * 一覧に表示するデータの取得
			 * 選択しているデータはisSelectプロパティを付与して返す
			 */
			getListItemInfo: function(info){
				if(((info[this.r_code_name] != null && this.r_code == info[this.r_code_name]) ||
					(info.text_code != null && this.r_code == info.text_code)) &&
					(!this.r_is_check_code2 || this.r_code2 == this.select_code2)){
					info.isSelect = true;
				}
				return info;
			}
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/parts_com/wndSelectOne.vue